import { AfterViewInit, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { YearService } from '../../../shared-components/year/year.service';
import { GPStudentNCourseInfoModel, GradPlanCoursesModel, GradPlanCreditCodeModel, GraduationPlanModel } from '../graduation-plan.model';
import { GraduationPlanService } from '../graduation-plan.service';

@Component({
    selector: 'app-override-creditcode',
    templateUrl: './override-creditcode.component.html',
    styleUrls: ['./override-creditcode.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class OverrideCreditcodeComponent implements AfterViewInit {

    @Input() gpCourseModel_selected: GradPlanCoursesModel;
    @Output() creditcode_Overriden = new EventEmitter();

    saveEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

    gpCourses: GradPlanCoursesModel[];
    gpOverrideCreditCodes: GradPlanCreditCodeModel[] = [];
    graduationPlans: GraduationPlanModel[];
    gpGPStudentNCourseInfoModel: GPStudentNCourseInfoModel;
    fromAcademicProgress: boolean;

    course_Id = -1;
    gradPlan_Id = -1;
    override_creditcode = '-1';

    instance: OverrideCreditcodeComponent;
    public errorList: ErrorList[] = [];

    constructor(
        private graduationplanService: GraduationPlanService,
        private dialogRef: MatDialogRef<OverrideCreditcodeComponent>,
        public yearService: YearService
    ) {
        this.instance = this;
    }

    ngAfterViewInit() {
        this.course_Id = this.gpCourseModel_selected.SSEC_ID;
        this.gradPlan_Id = this.gpCourseModel_selected.GradPlan_ID;
        if (!this.fromAcademicProgress) {
            this.graduationPlans = (!this.graduationPlans) ? this.graduationplanService.getAllDistinctGraduationPlans() : this.graduationPlans;
            this.gpCourses = this.graduationplanService.getAllCoursesByGradPlanID(this.gradPlan_Id);
        }
        setTimeout(() => this.load_gpGPStudentNCourseInfoModel());
    }

    saveOrCancel(save: boolean) {
        if (save) {
            const found = (!this.fromAcademicProgress) ? this.getSelectedCourseObject(this.course_Id) : this.gpCourseModel_selected;
            if (found) {
                if (this.override_creditcode == '-1') {
                    this.errorList.push({
                        fieldName: 'Override Credit Code',
                        fieldRef: undefined,
                        errorMsg: 'is required'
                    });
                }
                else {
                    const creditCodeModel: GradPlanCreditCodeModel = new GradPlanCreditCodeModel();
                    creditCodeModel.CreditCode = this.override_creditcode;

                    this.graduationplanService.overrideCreditCode(found.DataBucketScore_ID, found.SSEC_ID, this.gradPlan_Id, creditCodeModel.CreditCode).subscribe(x => {
                        this.saveEvent.emit(true);
                        this.graduationplanService.getgraduationplanData();
                        this.dialogRef.close();
                    });
                }
            }
        }
        else {
            this.dialogRef.close();
        }
    }

    load_gpGPStudentNCourseInfoModel() {
        this.graduationplanService.getStudentAndCourseInfo(
            this.gpCourseModel_selected.DataBucketScore_ID,
            this.gpCourseModel_selected.SSEC_ID
        ).subscribe(resultset => {
            this.gpGPStudentNCourseInfoModel = resultset;
            this.override_creditcode = this.gpGPStudentNCourseInfoModel.OverrideCreditCode;
            this.load_OverrideCreditCodes(this.gpCourseModel_selected.Course_ID);
        });
    }

    load_OverrideCreditCodes(course_ID: number) {
        const found = this.getSelectedCourseObject(course_ID);
        this.course_Id = found ? found.Course_ID : -1;

        this.graduationplanService.getGraduationPlanOverrideCreditCodes(
            this.gradPlan_Id,
            found ? found.DataBucketScore_ID : -1,
            found ? found.SSEC_ID : -1,
        ).subscribe(resultset => {
            this.gpOverrideCreditCodes = resultset;
            const creditfound = this.gpOverrideCreditCodes.filter(x => x.CreditCode == this.gpGPStudentNCourseInfoModel.OverrideCreditCode)[0];
            this.override_creditcode = creditfound ? creditfound.CreditCode : '-1';
        });
    }

    gradPlan_change() {
        this.gpCourses = this.graduationplanService.getAllCoursesByGradPlanID(this.gradPlan_Id);
        this.load_OverrideCreditCodes(this.gpCourseModel_selected.Course_ID);
    }

    course_change() {
        this.load_OverrideCreditCodes(this.course_Id);
    }

    getSelectedCourseObject(course_ID: number): GradPlanCoursesModel {
        return this.gpCourses.filter(x => x.Course_ID == course_ID)[0];
    }

}
